import { isBefore, format, isWeekend } from "date-fns";
import { APP_DATE_FORMAT } from "../constants";
const isPastDate = (date, terminalCurrentDate) => {
  return isBefore(date, terminalCurrentDate);
};
const isHoliday = (date, holidays) => {
  return isWeekend(date) || holidays.some((holiday) => holiday.holidayDate === format(date, APP_DATE_FORMAT));
};

const getHolidayName = (date, holidays) => {
  return holidays.find(
    (holiday) => holiday.holidayDate === format(date, APP_DATE_FORMAT)
  )?.holidayName;
};

const checkPlanAlreadyInitialized = (date, initializedDates) => {
  return initializedDates.some(
    (initializedDate) =>
      initializedDate.planDate === format(date, APP_DATE_FORMAT)
  );
};

const checkPlanAlreadyInitializedRange = (date, initializedDates) => {
  return initializedDates.some(
    ({ planDate, startDate }) =>
      format(date[0]?.endDate, APP_DATE_FORMAT) === planDate &&
      format(date[0]?.startDate, APP_DATE_FORMAT) == startDate
  );
};

export {
  isPastDate,
  isHoliday,
  getHolidayName,
  checkPlanAlreadyInitialized,
  checkPlanAlreadyInitializedRange,
};
